import { twMerge } from "tailwind-merge";

import {
  providerScreeningSectionTitle,
  ScreeningCode,
} from "~/common/utils/consultations/screening";
import { VERSIONS } from "~/providers/constants";
import { ScoreData } from "~/providers/utils/types/patientPreviewTypes";
import { SummaryVersion } from "~/providers/utils/types/SummariesVersionsTypes";

interface SelfReportedScoresCardProps {
  code: ScreeningCode;
  scoreData: ScoreData;
  version?: SummaryVersion;
}

export const SelfReportedScoresCard = ({
  code,
  scoreData: { score, label },
  version = VERSIONS.v1,
}: SelfReportedScoresCardProps) => {
  return (
    <div
      className={twMerge(
        "flex min-h-48 w-full flex-col items-center gap-3 rounded-md border-1.5 px-16 py-6",
        version === VERSIONS.v2 && "border-primary-300 bg-primary-50",
      )}
    >
      <h3 className="text-base font-semibold">
        {providerScreeningSectionTitle[code]}
      </h3>
      <div
        className={twMerge(
          "flex items-center justify-items-center rounded-md bg-primary-50 px-5 py-3",
          version === VERSIONS.v2 && "bg-primary-100",
        )}
      >
        <span className="text-4xl text-gray-70">{score}</span>
      </div>
      <span className="text-center font-light text-gray-70">{label}</span>
    </div>
  );
};
